module.exports = __webpack_public_path__ + "img/OK.f5182c9b.svg";